import React, {useState} from "react";
import {Link} from "react-router-dom";

interface ExtensionsFilterProps {
}

export const ExtensionsFilter: React.FC<ExtensionsFilterProps> = () => {

    return (
        <div className="filter clear" style={{width: '97.5%'}}>
            <form method="get">
                <p>
                    Pikendused lubavad logistikul, kelle e-logi konto lukus on, kasutada süsteemi tavapäraselt
                    märgitud aja jooksul.
                </p>
                <div className="content">
                </div>
                <p className="action">
                    <Link to="/extensions/new" className="filter-secondary">
                        Lisa uus pikendus
                    </Link>
                </p>
            </form>
        </div>
    )

}